//----------------------------------------- Animaciones mediante scroll ------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
    // Verifica si es un dispositivo móvil (ancho menor o igual a 768px)
    const isMobile = window.innerWidth <= 768;

    // Configuración de IntersectionObserver
    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const element = entry.target;

                    // Cambia de clase animatable a animated
                    element.classList.remove("animatable");
                    element.classList.add("animated");

                    // Solo aplica lógica de envoltorio en móviles y si tiene la clase bounceInRight
                    if (isMobile && element.classList.contains("bounceInRight")) {
                        wrapWithContainer(element);
                    }

                    // Deja de observar este elemento
                    observer.unobserve(element);
                }
            });
        },
        {
            threshold: 0.1, // Detecta el elemento cuando está al menos al 10% visible
        }
    );

    // Selecciona todos los elementos con la clase 'animatable'
    const animatables = document.querySelectorAll(".animatable");

    // Si hay elementos animables, comienza a observarlos
    if (animatables.length > 0) {
        animatables.forEach((animatable) => {
            observer.observe(animatable);
        });
    }

    // Función para envolver un elemento con un contenedor dinámico
    function wrapWithContainer(element) {
        // Verifica si ya tiene un contenedor
        if (element.parentElement && element.parentElement.classList.contains("Contenedor--overflow-hidden--bounceInRight")) {
            return;
        }

        // Crea el contenedor
        const wrapper = document.createElement("div");
        wrapper.classList.add("Contenedor--overflow-hidden--bounceInRight"); // Clase para ocultar desbordamiento
        wrapper.style.width = "100vw"; // Ancho completo del viewport

        // Calcula el alto dinámico del contenedor según el texto
        const height = element.offsetHeight;
        wrapper.style.height = `${height}px`;

        // Inserta el contenedor en el DOM y mueve el elemento dentro de él
        const parent = element.parentElement;
        if (parent) {
            parent.replaceChild(wrapper, element);
        }
        wrapper.appendChild(element);

        // Si no tiene text-align definido, se aplica text-align: center
        const computedStyle = window.getComputedStyle(element);
        if (!computedStyle.textAlign || computedStyle.textAlign === "start" || computedStyle.textAlign === "auto") {
            element.style.textAlign = "center";
        }
    }
});

//----------------------------------------- Animaciones de letras ------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
    console.log("Iniciando Splitting.js y ScrollOut.js para animaciones de texto.");

    const splittingResult = Splitting({
        target: '[class*="text--"]',
        by: 'chars',
    });
    console.log("Splitting.js inicializado:", splittingResult);

    ScrollOut({
        targets: '[data-scroll]',
        threshold: 0.9, // Detecta cuando el elemento es 90% visible
        once: true,     // La animación se ejecuta solo una vez
        onShown: (el) => {
            el.setAttribute('data-scroll', 'in');
            console.log(`"${el.textContent.trim()}" ahora está visible.`);
        },
        onHidden: (el) => {
            el.setAttribute('data-scroll', 'out');
            console.log(`"${el.textContent.trim()}" ya no es visible.`);
        }
    });

    // Configuración específica para Blowing
    initializeBlowingAnimation();

    // Configuración de las demás animaciones
    setupAnimation('.text--karaoke', { overlapFactor: 0.1 });
    setupAnimation('.text--slide', { reverse: true, overlapFactor: 0.1 });
    setupAnimation('.text--spinning', { overlapFactor: 0.1 });
    setupAnimation('.text--filling', { overlapFactor: 0.1 });
    setupAnimation('.text--scaling', { overlapFactor: 0.1 });
    setupAnimation('.text--turning', { overlapFactor: 0.1 });
    setupAnimation('.text--bulge', { overlapFactor: 0.1 });
    setupAnimation('.text--folding', { overlapFactor: 0.1 });
    setupAnimation('.text--tumbling', { reverse: true, overlapFactor: 0.1 }); // Configuración para Tumbling
    setupAnimation('.text--tumbling2', { overlapFactor: 0.1 }); // Configuración para Tumbling2
    setupAnimation('.text--rolling', { reverse: true, overlapFactor: 0.1 }); // Configuración para Tumbling
    setupAnimation('.text--perspective', { overlapFactor: 0.1 });
    setupAnimation('.text--zipping2', { overlapFactor: 0.1 });
    setupAnimation('.text--zipping', { overlapFactor: 0.1 });
    setupAnimation('.text--swinging', { reverse: true, overlapFactor: 0.1 });
    setupAnimation('.text--meeting', { overlapFactor: 0.1 });
});

/**
 * Configura las animaciones específicas para la clase "text--blowing".
 */
function initializeBlowingAnimation() {
    document.querySelectorAll('.text--blowing').forEach(element => {
        const chars = element.querySelectorAll('.char');
        const duration = parseFloat(element.getAttribute('data-duration')) || 1; // Duración total
        const delay = parseFloat(element.getAttribute('data-delay')) || 0; // Retraso inicial

        chars.forEach((char, index) => {
            // Aplica los controladores directamente a cada letra
            char.style.animationDuration = `${duration}s`;
            char.style.animationDelay = `${delay}s`;
        });

        console.log(`Animación "Blowing" configurada para "${element.textContent.trim()}" con duración: ${duration}s y retraso: ${delay}s.`);
    });
}

/**
 * Configura animaciones dinámicas para elementos de texto.
 * @param {string} selector - Selector CSS de los elementos.
 * @param {object} options - Opciones de configuración.
 * @param {boolean} [options.reverse=false] - Si las letras deben animarse de última a primera.
 * @param {number} [options.overlapFactor=0.1] - Factor de solapamiento entre letras.
 */
function setupAnimation(selector, { reverse = false, overlapFactor = 0.1 } = {}) {
    document.querySelectorAll(selector).forEach(element => {
        const chars = element.querySelectorAll('.char');
        const totalChars = chars.length;

        const duration = parseFloat(element.getAttribute('data-duration')) || 2; // Duración total
        const initialDelay = parseFloat(element.getAttribute('data-delay')) || 0; // Retraso inicial

        if (totalChars > 0) {
            const charStep = duration / totalChars; // Duración por carácter
            const overlap = charStep * overlapFactor; // Solapamiento entre letras

            chars.forEach((char, index) => {
                const adjustedIndex = reverse ? totalChars - index - 1 : index; // Controla el orden de animación
                const delay = initialDelay + adjustedIndex * (charStep - overlap);

                // Aplica las propiedades dinámicas
                char.style.setProperty('--char-delay', `${delay}s`);
                char.style.setProperty('--char-step', `${charStep}s`);
                char.style.setProperty('--char-duration', `${duration}s`);
            });

            console.log(`Animación configurada para "${selector}" con duración total: ${duration}s.`);
        }
    });
}

function setupDynamicTextColors() {
    document.querySelectorAll('.text--karaoke, .text--filling, .text--folding, .text--scaling, .text--spinning, .text--bulge, .text--flipping, .text--slide, .text--turning, .text--meeting, .text--zipping, .text--zipping2, .text--tumbling, .text--tumbling2, .text--rolling')
    .forEach(parentElement => {
        let parentColor = parentElement.getAttribute("data-color") || "#F2F3F3"; // Color por defecto
        console.log(`🎨 [PADRE] ${parentElement.tagName} - Texto: "${parentElement.textContent.trim()}" - Color detectado: ${parentColor}`);

        parentElement.querySelectorAll('.char').forEach((char, index) => {
            let currentElement = char;
            let charColor = null;

            // Buscar `data-color` en la jerarquía (h2, h3, span, etc.)
            while (currentElement && !charColor) {
                charColor = currentElement.getAttribute("data-color");
                currentElement = currentElement.parentElement;
            }

            // Si `span` tiene `data-color`, no sobrescribimos con el del padre
            if (char.closest("span[data-color]")) {
                charColor = char.closest("span[data-color]").getAttribute("data-color");
            }

            // Si no tiene un color definido, usa el del padre
            if (!charColor) {
                charColor = parentColor;
            }

            // Validar que el color sea un HEX válido
            if (!/^#([0-9A-F]{3}){1,2}$/i.test(charColor)) {
                console.warn(`⚠️ [ERROR] "${char.textContent}" tiene un data-color inválido o no definido: ${charColor}. Se usará #F2F3F3.`);
                charColor = "#F2F3F3"; // Color por defecto
            }

            console.log(`🎨 [CHAR ${index}] "${char.textContent}" - Color final asignado: ${charColor}`);

            // Aplicar color dinámico
            char.style.setProperty('--char-final-color', charColor);
        });

        console.log(`✅ Animación configurada para "${parentElement.textContent.trim()}"`);
    });
}

// Ejecutar cuando el DOM esté listo
document.addEventListener("DOMContentLoaded", () => {
    setupDynamicTextColors();
});


//----------------------------------------- Botón de música ------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const playPauseBtn = document.getElementById('play-pause-btn');
    const btnIcon = playPauseBtn.querySelector('.btn-icon');
    const audioPlayer = document.getElementById('audio-player');
    let isPlaying = false;

    // Evento de clic para reproducir/pausar
    playPauseBtn.addEventListener('click', () => {
        if (isPlaying) {
            audioPlayer.pause();
            btnIcon.src = 'build/img/SVG/Play.svg'; // Cambia al ícono de reproducción
        } else {
            audioPlayer.play();
            btnIcon.src = 'build/img/SVG/Pause.svg'; // Cambia al ícono de pausa
        }

        // Alterna el estado
        isPlaying = !isPlaying;

        // Aplica la animación de agrandamiento
        playPauseBtn.classList.add('playing');
        setTimeout(() => {
            playPauseBtn.classList.remove('playing');
        }, 300); // Coincide con la duración de la animación
    });

    // Pausar música si el usuario cambia de pestaña
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            audioPlayer.pause();
            btnIcon.src = 'build/img/SVG/Play.svg';
            isPlaying = false;
        }
    });
});

//----------------------------------------- Imagen hero cambiante ------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
    const pictureElement = document.querySelector(".background-image");
    const imgElement = pictureElement.querySelector("img");
    const sourceAvif = pictureElement.querySelector("source[type='image/avif']");
    const sourceWebp = pictureElement.querySelector("source[type='image/webp']");

    let currentIndex = 0;
    let intervalId;

    // Configuración para diferentes dispositivos
    const configsByDevice = {
        desktop: [
            { index: 1, scale: 1.3, objectPosition: "center 90%" },
            { index: 2, scale: 1, objectPosition: "center 30%" },
            { index: 3, scale: 1, objectPosition: "center 28%" },
            { index: 4, scale: 1, objectPosition: "center 13%" },
            { index: 5, scale: 1, objectPosition: "center 25%" }
        ],
        tablet: [
            { index: 1, scale: 1.3, objectPosition: "center center" },
            { index: 2, scale: 1, objectPosition: "center 40%" },
            { index: 3, scale: 1, objectPosition: "center 30%" },
            { index: 4, scale: 1, objectPosition: "center 10%" },
            { index: 5, scale: 1, objectPosition: "center 30%" }
        ],
        mobile: [
            { index: 1, scale: 1.3, objectPosition: "43% center" },
            { index: 2, scale: 1.2, objectPosition: "center center" },
            { index: 3, scale: 1.3, objectPosition: "center center" },
            { index: 4, scale: 1.1, objectPosition: "center center" },
            { index: 5, scale: 1.2, objectPosition: "center center" }
        ]
    };

    let imageConfigs = []; // Configuraciones actuales según el dispositivo

    // Detecta el dispositivo actual
    const detectDevice = () => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
            imageConfigs = configsByDevice.desktop;
        } else if (window.matchMedia("(min-width: 768px)").matches) {
            imageConfigs = configsByDevice.tablet;
        } else {
            imageConfigs = configsByDevice.mobile;
        }
    };

    // Detecta dispositivo al cargar la página y al cambiar el tamaño
    detectDevice();
    window.addEventListener("resize", detectDevice);

    // Función para actualizar una imagen específica
    const updateImage = (index) => {
        const { scale, objectPosition } = imageConfigs[index];

        // Cambia las rutas de las imágenes
        sourceAvif.srcset = `build/img/Hero/${index + 1}.avif`;
        sourceWebp.srcset = `build/img/Hero/${index + 1}.webp`;
        imgElement.src = `build/img/Hero/${index + 1}.jpg`;

        // Aplica configuraciones específicas
        imgElement.style.objectPosition = objectPosition || "center center";
        imgElement.style.transform = `scale(${scale || 1})`;

        // Asegura que la imagen esté visible
        imgElement.classList.add("visible");
        imgElement.classList.remove("hidden");
    };

    // Función para iniciar el ciclo automático
    const startAnimations = () => {
        intervalId = setInterval(() => {
            currentIndex = (currentIndex + 1) % imageConfigs.length;
            updateImage(currentIndex);
        }, 5000);
    };

    // Función para detener las animaciones
    const stopAnimations = () => {
        clearInterval(intervalId);
    };

    // Función para mostrar una imagen fija para edición
    window.showFixedImage = (imageNumber, scale = 1, objectPosition = "center center") => {
        stopAnimations(); // Detiene cualquier animación

        const config = imageConfigs[imageNumber - 1] || {}; // Obtiene la configuración de la imagen
        config.scale = scale; // Permite ajustar el scale manualmente
        config.objectPosition = objectPosition; // Permite ajustar el object-position manualmente

        // Aplica la configuración de la imagen específica
        updateImage(imageNumber - 1);

        console.log(`Imagen fija mostrada: ${imageNumber}, Scale: ${scale}, Position: ${objectPosition}`);
    };

    // Mostrar la primera imagen al cargar
    updateImage(currentIndex);


    // *Nota: Para probar una imagen individual y sus tamaños, se hizo estas funciones, para probar una imagen primero se debe comentar*
    // *La función startAnimations();, y luego des-comentar la función showFixedImage(x, x, "x x");, y para activar nuevo las animaciones*
    // *Normales, hay que hacer lo mismo pero en sentido contrario*

    // Detener la animación y probar imágenes una por una
    // showFixedImage(5, 1.2, "center center"); //Imagen, scale, posición

    // Inicia el ciclo automático
    startAnimations();
});

//----------------------------------------- Contador ------------------------------------------------

document.addEventListener("DOMContentLoaded", function() {
    function updateCountdown() {
        const targetDate = new Date("September 14, 2030 13:00:00").getTime();
        const now = new Date().getTime();
        const difference = targetDate - now;

        let days, hours, minutes, seconds;
        
        if (difference < 0) {
            // Si la diferencia es negativa, establecer todos los valores a 0
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;
        } else {
            // Calcular los días, horas, minutos y segundos restantes
            days = Math.floor(difference / (1000 * 60 * 60 * 24));
            hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            seconds = Math.floor((difference % (1000 * 60)) / 1000);
        }

        const daysElement = document.getElementById("days");
        const hoursElement = document.getElementById("hours");
        const minutesElement = document.getElementById("minutes");
        const secondsElement = document.getElementById("seconds");

        if (daysElement && hoursElement && minutesElement && secondsElement) {
            daysElement.textContent = days;
            hoursElement.textContent = hours;
            minutesElement.textContent = minutes;
            secondsElement.textContent = seconds;
        }
    }

    setInterval(updateCountdown, 1000);
    updateCountdown(); // Update countdown immediately on load
});

//----------------------------------------- Ubicación imagen hover Moviles ------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.button-with-icon');
    const redirectUrl = 'https://maps.google.com'; // URL de redirección

    // Lógica para los botones de redirección
    buttons.forEach((button) => {
        const loader = button.querySelector('.loader');
        const text = button.querySelector('.text');

        // Detecta si es un dispositivo táctil
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        // Evento click en el botón
        button.addEventListener('click', () => {
            if (isTouchDevice) {
                // En móviles: activa la clase `activateMaps` para la animación
                button.classList.add('activateMaps'); // Aplica la animación de hover

                // Agrega un retraso de 1.5 segundos antes de redirigir
                setTimeout(() => {
                    button.classList.remove('activateMaps'); // Quita la animación
                    window.location.href = redirectUrl; // Redirige
                }, 1000);
            } else {
                // En escritorio: redirige directamente
                window.location.href = redirectUrl;
            }
        });
    });
});

//----------------------------------------- Linea de itinerario ------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("Animacion");
                    observer.unobserve(entry.target); // Detiene la observación tras activar la animación
                }
            });
        },
        {
            threshold: 0.1, // Activa cuando el 20% del elemento es visible
        }
    );

    // Selecciona todos los elementos .lineItinerario que necesitan la animación
    const lines = document.querySelectorAll(".lineItinerario");
    lines.forEach((line) => observer.observe(line));
});

//----------------------------------------- Asistencia ------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const checkbox1 = document.getElementById('cbx1');
    const checkbox2 = document.getElementById('cbx2');
    const btnRespuesta = document.querySelector('.btn_respuesta');

    if (checkbox1 && checkbox2 && btnRespuesta) {
        checkbox1.addEventListener('change', function() {
            if (checkbox1.checked) {
                checkbox2.checked = false;
            }
        });

        checkbox2.addEventListener('change', function() {
            if (checkbox2.checked) {
                checkbox1.checked = false;
            }
        });

        btnRespuesta.addEventListener('click', function() {
            if (checkbox1.checked) {
                window.location.href = 'https://wa.me/############?text=Le confirmo mi asistencia a los XV años de Regina del 14 de Septiembre del 2030 a las 4pm, mi nombre es: ';
            } else if (checkbox2.checked) {
                window.location.href = 'https://wa.me/############?text=Lamento confirmar mi inasistencia a los XV años de Regina del 14 de Septiembre del 2030 a las 4pm, mi nombre es: ';
            } else {
                alert('Debe seleccionar un campo de los dos');
            }
        });
    }
});

//----------------------------------------- Barra infinita hashtag ------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
    const marqueeContainer = document.querySelector(".ue-marquee");
    const marqueeContent = document.querySelector(".ue-marquee-content");

    if (!marqueeContainer || !marqueeContent) return;

    // Obtener el texto original y duplicarlo dinámicamente
    const originalText = marqueeContent.textContent.trim();
    marqueeContent.innerHTML = `<a href="https://www.instagram.com/explore/tags/xvdereginaruiz/" class="ue-marquee-tag">${originalText} &nbsp;&nbsp;</a>`.repeat(10);

    let scrollPosition = 0;
    const speed = 1; // Velocidad de movimiento
    let isPaused = false;

    function moveMarquee() {
        if (!isPaused) {
            scrollPosition -= speed;
            marqueeContent.style.transform = `translateX(${scrollPosition}px)`;

            const firstElement = marqueeContent.firstElementChild;
            if (firstElement.getBoundingClientRect().right <= marqueeContainer.getBoundingClientRect().left) {
                // **Mover el primer elemento al final de la fila**
                marqueeContent.appendChild(firstElement);
                scrollPosition += firstElement.offsetWidth; // **Corrige la posición**
                marqueeContent.style.transform = `translateX(${scrollPosition}px)`;
            }
        }
        requestAnimationFrame(moveMarquee);
    }

    moveMarquee();

    // Eventos para pausar/reanudar animación en hover
    marqueeContainer.addEventListener("mouseenter", () => isPaused = true);
    marqueeContainer.addEventListener("mouseleave", () => isPaused = false);

    // Permitir que los enlaces sean clickeables
    marqueeContent.addEventListener("click", (event) => {
        if (event.target.classList.contains("ue-marquee-tag")) {
            window.open(event.target.href, "_blank"); // Abrir en nueva pestaña
        }
    });
});


//----------------------------------------- Galería ------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.querySelector('.galeria__overlay');
    const botonCerrar = document.querySelector('.galeria__cerrar');
    const imagenAmpliada = document.querySelector('.galeria__imagen');
    const body = document.body;

    if (!overlay || !imagenAmpliada || !botonCerrar) return;

    document.addEventListener('click', (e) => {
        const imagenClickeada = e.target.closest('picture');

        if (imagenClickeada && imagenClickeada.closest('.galeria-grid')) {
            const avif = imagenClickeada.querySelector("source[type='image/avif']");
            const webp = imagenClickeada.querySelector("source[type='image/webp']");
            const fallback = imagenClickeada.querySelector("img");

            if (avif && avif.srcset) {
                imagenAmpliada.src = avif.srcset;
            } else if (webp && webp.srcset) {
                imagenAmpliada.src = webp.srcset;
            } else if (fallback) {
                imagenAmpliada.src = fallback.src;
            }

            overlay.classList.add('activa');
            overlay.setAttribute('aria-hidden', 'false');
            body.style.overflow = 'hidden'; // Desactiva el scroll
        }
    });

    botonCerrar.addEventListener('click', () => {
        overlay.classList.remove('activa');
        overlay.setAttribute('aria-hidden', 'true');
        body.style.overflow = ''; // Reactiva el scroll
        imagenAmpliada.src = '';
    });

    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
            overlay.classList.remove('activa');
            overlay.setAttribute('aria-hidden', 'true');
            body.style.overflow = '';
            imagenAmpliada.src = '';
        }
    });
});
